export enum IncomingMessages {
    authentication = 'authentication'
}

export enum OutgoingMessages {
    requestAuthentication = 'request-authentication'
}

export const parseMessage = message => {
    try {
        return JSON.parse(message);
    } catch {
        return null;
    }
};
